import { defineStore } from "pinia";
import { privateBoaHttp } from "@/boa-api-client";
import type { HTTPError } from "ky";
import type { Customer, Invoice, PaymentMethod } from "best-of-awards-api";

type State = {
  customers: Customer[];
  customersLoading: boolean;
  invoices: { data: Invoice[]; has_more: boolean };
  invoicesLoading: boolean;
  paymentMethods: { data: PaymentMethod[]; has_more: boolean };
  paymentMethodsLoading: boolean;
};

export default defineStore("payments", {
  state: (): State => ({
    customers: [],
    customersLoading: false,
    invoices: {
      has_more: false,
      data: [],
    },
    invoicesLoading: false,
    paymentMethods: {
      has_more: false,
      data: [],
    },
    paymentMethodsLoading: false,
  }),
  getters: {
    loading: (state) => state.invoicesLoading || state.paymentMethodsLoading,
  },
  actions: {
    // async getInvoice(id: string): Promise<Invoice> {
    //   this.invoicesLoading = true;
    //   try {
    //     return testInvoices.find((invoice) => invoice.id === id);
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.invoicesLoading = false;
    //   }
    // },
    // async getInvoices({
    //   stripeCustomerId,
    //   limit = 10,
    //   startingAfter = "",
    // }: {
    //   stripeCustomerId?: string;
    //   limit: number;
    //   startingAfter: string;
    // }): Promise<void> {
    //   console.log("getInvoices", { stripeCustomerId, limit, startingAfter });
    //   this.invoicesLoading = true;
    //   try {
    //     // const invoices = await privateBoaHttp("invoices").json();
    //     // return invoices;
    //     const { has_more, data } = {
    //       has_more: true,
    //       data: testInvoices.filter(
    //         (invoice) => invoice.customer === stripeCustomerId
    //       ),
    //     };
    //     this.invoices = { has_more, data };
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.invoicesLoading = false;
    //   }
    // },
    // async getPaymentMethods({
    //   stripeCustomerId,
    // }: {
    //   stripeCustomerId: string;
    // }): Promise<void> {
    //   console.log("getPaymentMethods");
    //   this.paymentMethodsLoading = true;
    //   try {
    //     const { has_more, data } = {
    //       has_more: true,
    //       data: testPaymentMethods.filter(
    //         (paymentMethod) => paymentMethod.customer === stripeCustomerId
    //       ),
    //     };
    //     this.paymentMethods = { has_more, data };
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.paymentMethodsLoading = false;
    //   }
    // },
    async getCustomers(): Promise<void> {},
    async verifyPaymentMethod(
      candidateId: string,
      {
        setupIntent,
        amountOne,
        amountTwo,
        descriptorCode,
      }: {
        setupIntent: any;
        amountOne?: number;
        amountTwo?: number;
        descriptorCode?: string;
      }
    ) {
      try {
        const response: { verified: boolean } = await privateBoaHttp
          .post("stripe/verify-payment-method", {
            json: {
              candidateId,
              setupIntent,
              amountOne,
              amountTwo,
              descriptorCode,
            },
          })
          .json();
        // console.log(response);
        return response;
      } catch (error) {
        const response = await (error as HTTPError).response.json();
        return response;
      }
    },
    clear() {
      this.$reset();
    },
  },
});
